import { render, staticRenderFns } from "./ImportOTForm.vue?vue&type=template&id=f0c81d9c&scoped=true"
import script from "./ImportOTForm.vue?vue&type=script&lang=js"
export * from "./ImportOTForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c81d9c",
  null
  
)

export default component.exports